import { type ServiceConfig } from '../../ServiceRegistry';
import BaseService from '@/services/BaseService';

/**
 * Factory for registering an extra `BaseService` pointed at `/api/authorization-service`.
 */
export const createAuthorizationCustomService = (
  serviceName: string,
  baseUrl: string = '/api/authorization-service',
): ServiceConfig => ({
  name: serviceName,
  factory: () => new BaseService(baseUrl),
});
